import { useState } from "react";
import { FaCheck } from "react-icons/fa6";
import { FiCopy } from "react-icons/fi";

const CopyButton = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!copied) {
      navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="flex justify-center items-center gap-2">
      <span>{text}</span>
      <button
        onClick={handleCopy}
        className="p-2 rounded-md hover:bg-gray-100 active:text-gray-400 transition-colors"
        aria-label="Copy email"
      >
        <div className="md:text-[1.5rem]">
          {copied ? <FaCheck /> : <FiCopy />}
        </div>
      </button>
    </div>
  );
};

export default CopyButton;
